import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../../components/AsyncTypeahead";
import { ToastConfig } from "../../../components/Toaster";
import { Datepicker, MbscDatepickerChangeEvent } from "@mobiscroll/react";
import { createCommonUtilsApi, createCommonUtilsIcdApi } from "../../../api-helpers/CommonUtilsApiHelper";
import { GetPatientConditions, SaveConditionRequest } from "patients-experience-client";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { Lookup } from "common-util-experience-client";
import Lookups from "../../../constants/Lookups";


interface ConditionProps{
  patientId : string,
  onSubmitCondition: (toasterConfig: ToastConfig) => void,
  setOffCanvasShow: Dispatch<SetStateAction<boolean>>,
  selectedCondition?: GetPatientConditions,
  reloadGrid: () => void,
}

export const AddConditions = (props: ConditionProps) => {
  const [conditionForm, setConditionForm] = useState<SaveConditionRequest >({
    conditionId:"",
    status: "",
    details: "",
    conditionRecStatusId: "",
  });
  const [conditionApiResponse, setConditionApiResponse] = useState({} as GetPatientConditions);
  const [conditionsList, setConditionsList] = useState<DataListType[]>([]);
  const [conditionCategories, setConditionCategories] = useState<Lookup[]>([]);
  const [conditionStatus, setConditionStatus] = useState<Lookup[]>([]);
  const [conditionReconciliationStatus, setConditionReconciliationStatus] = useState<Lookup[]>([]);
  const [onSetDatePicker, setOnSetDatePicker] = useState<boolean>(false);



  const [validated, setValidated] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const selectedConditionId = props.selectedCondition?.conditionId
  const patientApi = createPatientApi()
  const apiIcd = createCommonUtilsIcdApi()
  const apiLookup=createCommonUtilsApi()


  const getConditionStatus = async () => {
    try {
        const response= await apiLookup.lookupControllerFindAll(Lookups.CONDITION_STATUS);
        setConditionStatus(response.data.sort((a:Lookup, b:Lookup) => a.sequence - b.sequence));
    } catch (error) {
      console.log(error);
    } finally {
      console.log(conditionStatus);
    }
  };
  
  const getConditionReconciliationStatus = async () => {
    try {
      const response = await apiLookup.lookupControllerFindAll(Lookups.CONDITION_RECONCILIATION_STATUS); // Replace with the correct lookup key for conditions
      setConditionReconciliationStatus(response.data.sort((a: Lookup, b: Lookup) => a.sequence - b.sequence));
    } catch (error) {
      console.error('Error fetching condition reconciliation status:', error);
    }
  };
  

  const selectCondition = (selected: any) => {
    setConditionForm({
      ...conditionForm,
      conditionId: selected && selected.key
    });
  };

  const loadConditionsList = async (query: string) => {
    if (!query || query === '') {
      setConditionsList([]);
      return;
    }
    try {
      const conditionsResponse = await apiIcd.icdCodesControllerTypeHead(query) 

      const conditions = conditionsResponse.data.map( (item:any) => ({
        key: item.key,
        value: item.value}))

      setConditionsList(conditions)

    } catch (error) {
      console.log(error);
    }
  };

  const getConditionDetailsById = async () => {
    
    const conditionId = props.selectedCondition && props.selectedCondition.conditionId!
    if (conditionId) {
      try {
        const conditionsResponse= await patientApi.patientsControllerGetConditionById(props.patientId, conditionId);
        const conditions = conditionsResponse.data;
        setConditionApiResponse(conditions);
        setConditionForm({
          conditionId: conditions.conditionId!,
          categoryId: conditions.categoryId!,
          status: conditions.status!,
          details: conditions.details!,
          onsetDate: conditions.onsetDate,
          conditionRecStatusId: conditions.conditionRecstatus

        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getConditionCategory = async () => {
    try {
        const response= await apiLookup.lookupControllerFindAll(Lookups.CONDITION_CATEGORY);
        setConditionCategories(response.data.sort((a:Lookup, b:Lookup) => a.sequence - b.sequence));
    } catch (error) {
      console.log(error);
    }
  };

  const showResponseMessage = (response: any) => {
    let toasterConfig: ToastConfig;
    const isError = response.statusCode.toString().charAt(0) === '4' || response.statusCode.toString().charAt(0) === '5'
    if (isError) {
      toasterConfig= {
        type:'danger',
        title: `${response.message}`,
        icon: "error_outline",
      };
      props.onSubmitCondition(toasterConfig as ToastConfig);
    } else {
      setTimeout(() => {
        handleDiscard();
      }, 500);
      toasterConfig= {
        type:'success',
        title: `${response.message}`,
        icon: "check_circle_outline",
      };
      props.onSubmitCondition(toasterConfig as ToastConfig);
      handleDiscard();
    }
  }

  const handleDiscard = () => {
    props.setOffCanvasShow(false);
  };

  const dateRangeChangeHandler = (args: MbscDatepickerChangeEvent) => {
    setConditionForm({
      ...conditionForm,
      onsetDate: new Date(args.valueText!)
    });
  };

  const onChange = (event: any) => {
    const newState = {
      ...conditionForm,
      [event.target.name]: event.target.value,
    };
    setConditionForm(newState);
  };

  const onsubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsProcessing(true)
    event.preventDefault();
    setValidated(true);

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      setIsProcessing(false)
      return;
    }

    const updateData = {
      categoryId: conditionForm.categoryId,
      status: conditionForm.status,
      details: conditionForm.details?.trim(),
      onsetDate: conditionForm.onsetDate 
  ? new Date(conditionForm.onsetDate).toDateString()
  : undefined,
conditionRecStatusId: conditionForm.conditionRecStatusId
    }

    const saveConditionData = {
      ...conditionForm,
      details: conditionForm.details?.trim(),
    }

    let conditionsResponse;
    try {
      if(props.selectedCondition){
        conditionsResponse = await patientApi.patientsControllerUpdateCondition(updateData, props.patientId, selectedConditionId!)
      } else {      
        conditionsResponse = await patientApi.patientsControllerAddCondition(saveConditionData, props.patientId)
      }
    } catch (error) {
      console.error(error);
      setIsProcessing(false)
    } finally {
      setIsProcessing(false)
      if (conditionsResponse) {
        showResponseMessage(conditionsResponse.data)
      }
      props.reloadGrid();
    }
  };

  useEffect(() => {
    
    getConditionCategory();
    getConditionStatus();
    getConditionReconciliationStatus();
    
    // Checking if selected condition is present
    if (props.selectedCondition){
      
      getConditionDetailsById()
    }
  }, []);
  

  return (
    <>
      <Form
        className="d-flex flex-column h-100 formAddCondition"
        noValidate
        validated={validated}
        onSubmit={onsubmit}
      >
        <div className="flex-fill pb-2">
          <div className="mb-3">
            <label
              htmlFor="assignedTo"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Condition
            </label>
            {
              props.selectedCondition ? 
              <input
                type="text"
                className="form-control"
                value={conditionApiResponse.conditionName} // Assuming `name` is a field in patientDetails
                disabled
              /> :
                <AsyncTypeahead
                  name="conditionId"
                  defaultValue={''}
                  options={conditionsList}
                  onSelect={selectCondition}
                  callback={loadConditionsList}
                  placeholder={"Search Condition"}
                  required={true}
                />  
              }
           
          </div>

          {/* Category */}
          <div className="mb-3">
            <label
              htmlFor="categoryId"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Category
            </label>
            <select
              className={`form-select form-select-sm ${conditionCategories.length > 0 ? '' : 'placeholder-wave'}` }
              name="categoryId"
              id="category"
              value={conditionForm.categoryId}
              onChange={(e) => { onChange(e) }}
              required={true}
            >
              <option value="" >Select Category</option>
              {conditionCategories.map((category:Lookup, index: number) => (
                <option key={index} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>


          <div className="row g-2 mb-3">
            <div className="col-6">
              <label className="form-label fs-12 fw-semibold mb-1">
                Status
              </label>
              <div className="border rounded px-1 pt-1">
                {
                  conditionStatus.map((status: Lookup, index: number) => (
                    <div key={index} className={`form-check form-check-inline ${index ? 'me-0':''}`}>
                      <div>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={`inlineRadio${index}`}
                          value={status.id}
                          checked={conditionForm.status === status.id? true : false}
                          onChange={(e) => setConditionForm({...conditionForm, status: e.target.value })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`inlineRadio${index}`}
                        >
                          {status.name}
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="col-6">
              <label
                htmlFor="toDate"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Onset Date
              </label>
              <div className="mobiscroll">
                <div className="mobiscroll__calendar">
                  <Datepicker
                    controls={["calendar"]}
                    value={conditionForm.onsetDate}
                    placeholder="MM/DD/YYYY"
                    onChange={dateRangeChangeHandler}
                    theme="windows"
                    display="bubble"
                    touchUi={true}
                    showOnClick={false}
                    isOpen={onSetDatePicker}
                    onClose={() => {setOnSetDatePicker(false)}}
                    themeVariant="light"
                    max={new Date().toISOString()}
                    buttons={[]}
                    required
                  />
                </div>
                    <div onClick={() => setOnSetDatePicker(!onSetDatePicker)} className="mobiscroll__calendar-icon">
                        <span className="material-symbols-outlined fs-18" >
                          calendar_month
                        </span>
                    </div>
              </div>
            </div>
          </div>
          <div className="col-12 mb-3">
          <label className="form-label fs-12 fw-semibold mb-1">
            Condition Reconciliation Status
          </label>
          <div className="border rounded px-3 py-1">
            {conditionReconciliationStatus.map((status: Lookup, index: number) => (
              <div
                key={index}
                className={`form-check form-check-inline ${index ? 'me-2' : ''}`}
              >
                <div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="conditionRecStatus"
                    id={`conditionRecStatus${index}`}
                    value={status.id}
                    checked={
                      conditionForm.conditionRecStatusId === status.id ? true : false
                    }
                    onChange={(e) =>
                      setConditionForm({
                        ...conditionForm,
                        conditionRecStatusId: e.target.value,
                        
                      })
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`conditionRecStatus${index}`}
                  >
                    {status.name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
          <div className="mb-3">
            <label htmlFor="details" className="form-label fs-12 fw-semibold mb-1">
              Details
            </label>
            <textarea
              name="details"
              className="form-control form-control-sm"
              placeholder="Type details.."
              rows={6}
              value={conditionForm.details}
              onChange={(e) => setConditionForm({ ...conditionForm, details: e.target.value })}
            ></textarea>
          </div>
        </div>

        <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
          <div>
            <button
              className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
              type="reset"
              onClick={handleDiscard}
            >
              Discard
            </button>
          </div>
          <div>
            <button
              className="btn btn-sm btn-secondary rounded-pill ps-4 pe-5 fs-13"
              type="submit"
              disabled = {isProcessing}
            >
              <span className="material-symbols-outlined fs-16 align-text-top">
              {isProcessing ? "" : props.selectedCondition ? ""  : "add"}
              </span>
              {isProcessing ? "Processing..." : props.selectedCondition ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};
